import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { map, Observable, of } from 'rxjs';

import { Sport } from 'app/modules/browse/models/sport';
import { SearchedTermStore } from 'app/modules/browse/store/searched-term/searched-term.store';
import { SportStore } from 'app/modules/browse/store/sport/sport.store';
import { ResponsiveService } from 'app/services/responsive.service';
import { LARGE_SCREEN_BREAKPOINT } from 'src/environments/environment.local';
import { TranslateModule } from '@ngx-translate/core';
import { SearchPlaceBarComponent } from '../../../components/search-place-bar/search-place-bar.component';
import { SearchBarComponent } from '../../../components/search-bar/search-bar.component';
import { SportSelectorComponent } from '../../../components/sport-selector/sport-selector.component';
import { BackButtonComponent } from '../../../components/back-button/back-button.component';
import { NgIf, NgClass, AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-search-toolbar',
  templateUrl: './search-toolbar.component.html',
  styleUrls: ['./search-toolbar.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    BackButtonComponent,
    SportSelectorComponent,
    SearchBarComponent,
    NgClass,
    SearchPlaceBarComponent,
    AsyncPipe,
    TranslateModule,
  ],
})
export class SearchToolbarComponent implements OnInit {
  sports$: Observable<Sport[]>;
  selectedSport$: Observable<Sport>;
  typedTerm$: Observable<string>;
  isSmallScreen$: Observable<boolean>;
  @Input() searchDisplay: 'list' | 'map';
  @Output() searchDisplayChange: EventEmitter<'list' | 'map'>;

  constructor(
    private searchStore: SearchedTermStore,
    private router: Router,
    private route: ActivatedRoute,
    private responsiveService: ResponsiveService,
    private sportStore: SportStore
  ) {
    this.sports$ = this.sportStore.sports$;
    this.selectedSport$ = this.sportStore.selectedSport$;
    this.typedTerm$ = this.searchStore.searchedTerm$;
    this.isSmallScreen$ = this.responsiveService.width$.pipe(
      map((screenSize) => {
        return screenSize <= LARGE_SCREEN_BREAKPOINT;
      })
    );
    this.searchDisplay = 'list';
    this.searchDisplayChange = new EventEmitter<'list' | 'map'>();
  }

  onChangeSport(sport: Sport) {
    this.typedTerm$ = this.searchStore.searchedTerm$;
    this.sportStore.setSelectedSport(sport);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onChangeTypedTerm(term: string) {
    this.typedTerm$ = of(term);
  }

  onSearchTerm(term: string): void {
    this.router.navigate(['/browse/search', term], {
      relativeTo: this.route,
    });
  }

  onChangeSearchDisplay(display: 'list' | 'map'): void {
    if (this.searchDisplay === display) {
      return;
    }
    this.searchDisplayChange.next(display);
  }

  onGoBackToCatalog(): void {
    this.router.navigate(['browse']);
  }

  ngOnInit(): void {
    if (this.route.snapshot.queryParams?.display === 'map') {
      this.onChangeSearchDisplay('map');
    }
  }
}
